import * as React from 'react'
import { useParams } from 'react-router-dom'
import { Alert, Box, Container, Divider } from '@mui/material'
import TitleBar from 'components/TitleBar'
import DeliveryDatePicker from 'components/DeliveryDatePicker'
import Filters from './components/Filters'
import OrderList from './components/OrderList'
import { OrdersContext } from 'contexts/ordersContext'

/**
 * PriceSheet component for displaying order list with pricing
 */
const PriceSheet = () => {
  const [filters, setFilters] = React.useState({ search: '' })
  const { orders, fetchOrders } = React.useContext(OrdersContext)
  const { deliveryDate } = useParams()

  // Fetching orders
  React.useEffect(() => {
    fetchOrders(deliveryDate)
  }, [deliveryDate, fetchOrders])

  // Formatting data
  const formattedOrders = orders.map((order) => ({
    ...order,
    gst: order.taxes[0]?.amount ?? 0,
    qst: order.taxes[1]?.amount ?? 0,
  }))

  // Filtering data
  const filteredOrders = formattedOrders.filter((order) => {
    const search = filters.search.toLowerCase()
    return order.customerName.toLowerCase().includes(search) || order.orderNo.toLowerCase().includes(search)
  })

  return (
    <Box>
      <TitleBar title="Price Sheet" actions={[<DeliveryDatePicker />]} />
      <Container maxWidth="xl">
        <Filters filters={filters} setFilters={setFilters} />
        <Divider />
        {filteredOrders.length > 0 ? (
          <OrderList orders={filteredOrders} />
        ) : (
          <Alert severity="warning" sx={{ my: 6, border: 1, borderColor: 'warning.light' }}>
            No orders found.
          </Alert>
        )}
      </Container>
    </Box>
  )
}

export default PriceSheet
